import firebase from 'firebase'

import { FIREBASE_AUDIENCE as audience } from './environment'

const firebaseConfig = {
  apiKey: 'AIzaSyA2tPw76xrWk9BnsUTeMwTE-oCKq5xIV5U',
  authDomain: 'multipolar-4c370.firebaseapp.com',
  databaseURL: 'https://multipolar-4c370-default-rtdb.europe-west1.firebasedatabase.app',
  projectId: 'multipolar-4c370',
  storageBucket: 'multipolar-4c370.firebasestorage.app',
  messagingSenderId: '260258385668',
  appId: '1:260258385668:web:c888cd0bbf1df1d80dca51',
  measurementId: 'G-KXKNKJH5WE',
}

type ErrorHandler = (error: any) => void

class RealtimeService {
  private _database: firebase.database.Database | null

  constructor() {
    this._database = null
  }
  get database() {
    if (!this._database) {
      throw new Error('_database not initialized!')
    }
    return this._database
  }

  init(initRealtimeEndpoints: () => void) {
    if (this._database) {
      console.log('already initialized')
      return
    }
    firebase.initializeApp(firebaseConfig)
    this._database = firebase.database()
    initRealtimeEndpoints()
    // userManager
    //   .callAPI('auth/firebase', true)
    //   .then((response: any) => {
    //     const token = response.firebaseToken
    //     firebase
    //       .auth()
    //       .signInWithCustomToken(token)
    //       .then(() => {
    //         dispatch(initRealtimeEndpoints()).then(() => {
    //           console.log('realtime ready')
    //         })
    //       })
    //       .catch((error) => {
    //         alert(`realtime sign in error: ${error}`)
    //       })
    //   })
    //   .catch((error) => {
    //     alert(`realtime unavailable: ${error}`) // TODO: propagate?
    //   })
  }

  endpoint(path: string) {
    return this.database.ref(`${audience}/${path}`)
  }

  endpointOnce(path: string, defaultValue: any = undefined): Promise<any> {
    const ref = this.database.ref(`${audience}/${path}`)
    return new Promise((resolve, reject) => {
      const onData = (snapshot: firebase.database.DataSnapshot) => {
        const value = snapshot.val()
        resolve(value || defaultValue)
      }
      const onError = (error: Object) => {
        reject(error)
      }
      ref.once('value', onData, onError)
    })
  }

  /* Wrapper for endpoint.set:
    If endpoint.set is called with bad parameters, it will throw without calling the handler
    e.g. if any object in the payload contains an undefined value (an easy bug to have).
    Log (or call custom handler) before rethrowing in case caller is swallowing exceptions
    e.g. a redux toolkit thunk which, by conveniently converting expections into .rejected actions,
    will result in exceptions being lost if action not explicitly handled in a reducer .
   */
  set(path: string, payload: any, errorHandler: ErrorHandler = this.defaultErrHandler) {
    try {
      return this.endpoint(path).set(payload, errorHandler)
    } catch (error) {
      errorHandler(error)
      throw error
    }
  }
  // update(path: string, payload: any, errorHandler: ErrorHandler = this.defaultErrHandler) {
  //   try {
  //     return this.endpoint(path).update(payload, errorHandler)
  //   } catch (error) {
  //     errorHandler(error)
  //     throw error
  //   }
  // }
  //
  // push(path: string, payload: any, errorHandler: ErrorHandler = this.defaultErrHandler) {
  //   try {
  //     return this.endpoint(path).push(payload, errorHandler)
  //   } catch (error) {
  //     errorHandler(error)
  //     throw error
  //   }
  // }
  // TODO: make this dev only until we do backend logging?
  defaultErrHandler(error: any) {
    if (error) {
      console.log('realtime error', error.message)
    }
  }
}

const defaultRealtimeService = new RealtimeService()
export default defaultRealtimeService
